import { render, staticRenderFns } from "./commonDate.vue?vue&type=template&id=28b3f075&scoped=true"
import script from "./commonDate.vue?vue&type=script&lang=js"
export * from "./commonDate.vue?vue&type=script&lang=js"
import style0 from "./commonDate.vue?vue&type=style&index=0&id=28b3f075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3f075",
  null
  
)

export default component.exports